import React from 'react'
import styles from './HowItWorksLarge.module.css'
import howItWorksLarge from 'assets/img/how-it-works-large.jpg'
import LazyImg from 'app/theme/LazyImage'

const defaultItems = [
  { title: 'Give Us Details', description: 'Tell us when & where you want food truck catering.' },
  { title: 'Choose Your Cuisine', description: 'We\'ll send you a list of available food trucks.' },
  { title: 'Get Ready to Dig In', description: 'We\'ll negotiate the best rate and coordinate the logistics.' },
]

export default function HowItWorksLarge(props) {
  const {
    heading = 'How It Works',
    className,
    buttonText = 'Get Started',
    onButtonClick,
    items = defaultItems,
    ...rest
  } = props

  return (
    <section
      {...rest}
      className={[
        className,
        'text-navy pt-16 pb-20 hidden lg:block'
      ]}
    >
      <div className="container">
        <h2 className="font-platform text-center mb-10 text-3xl lg:text-4xl">
          {heading}
        </h2>
        <div className="flex items-center flex-row">
          <div className='flex-grow p-4'>
            <LazyImg src={howItWorksLarge} />
          </div>

          <div className='flex-grow'>
            {items.map((item, index) => (
              <div className={['flex', (index !== 0 && 'mt-6')]} key={index}>
                <div className={[styles.circle, 'm-auto mb-2 border-2 border-navy rounded-full text-center']}>
                  {index + 1}
                </div>
                <div className="flex-grow ml-6">
                  <h3 className='text-3xl leading-tight'>{item.title}</h3>
                  <p className='text-xl font-light'>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <button
          type="button"
          children={buttonText}
          className='btn btn-green text-2xl font-platform block px-10 py-3 mt-12 m-auto'
          onClick={onButtonClick}
        />
      </div>
    </section>
  )
}
